import PropTypes from 'prop-types';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

import './CustomAccordian.css';
const CustomAccordion = props => {
  return (
    <Box className='CustomAccordion'>
      <Accordion
        expanded={props.isOpen}
        onChange={props.isOpen ? props.onClose : props.onOpen}
        boxShadow={props.boxShadow}
        style={{
          marginBottom: '1em',
          marginTop: '0px',
          border: '1px solid #e1e1e1',
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon color='primary' />}>
          <Typography variant='h3'> {props.title} </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Divider/>
          {props.children}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

CustomAccordion.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
};
export default CustomAccordion;
